import React from "react";
import { styled, borderRadius, hiddenTextCss } from "@iventis/styles";

import { Step, Stepper, StepLabel } from "@mui/material";
import { Content } from "@iventis/translations/content/typed-content";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { ProgressStep } from "./sign-up-questionnaire";

export interface StepProgressProps {
    steps: ProgressStep[];
    startingStep: number;
}

const StepPill = ({ active, completed }) => <StyledDiv ownerState={{ active, completed }} />;

export const StepIndicator: React.FC<StepProgressProps> = ({ steps, startingStep }) => {
    const translate = useIventisTranslate();
    return (
        <>
            <Stepper style={{ margin: "auto" }} activeStep={startingStep} alternativeLabel connector={null}>
                {steps.map((step) => (
                    <StyledStep key={step.label}>
                        <StyledStepLabel StepIconComponent={StepPill}>
                            <span className="hidden">{step.label}</span>
                        </StyledStepLabel>
                    </StyledStep>
                ))}
            </Stepper>
            <StyledSpan>{translate(Content.login2.questionnaire.steps, { currentStep: startingStep + 1, totalSteps: steps.length })}</StyledSpan>
        </>
    );
};

export const StyledDiv = styled("div")<{ ownerState: { completed?: boolean; active?: boolean } }>(({ theme, ownerState }) => ({
    background: ownerState.active || ownerState.completed ? theme.primaryColors.subdued70 : theme.shades.lightBorder,
    borderRadius: borderRadius.double,
    width: "70px",
    height: "12px",
    margin: "10px 0",
}));

const StyledStepLabel = styled(StepLabel)`
    height: 40px;
    ${hiddenTextCss}
`;

const StyledSpan = styled("span")(({ theme }) => ({
    color: theme.primaryColors.subduedMono,
    display: "flex",
    justifyContent: "center",
}));

const StyledStep = styled(Step)`
    flex: 0 1 auto;
`;
